import { api } from '../../../lib/api';
import { CopilotMessage } from '../../../types';

// Map snake_case/camelCase API responses to the CopilotMessage type. The REST
// endpoints return snake_case (Pydantic); the socket broadcast sends camelCase.
function mapCopilotMessage(raw: Record<string, any>): CopilotMessage {
  const metadata = raw.message_metadata ?? raw.messageMetadata ?? {};
  return {
    id: raw.id,
    sessionId: raw.session_id ?? raw.sessionId ?? '',
    role: raw.role,
    content: raw.content ?? '',
    staffId: raw.staff_id ?? raw.staffId ?? null,
    staffName: raw.staff_name ?? raw.staffName ?? null,
    toolSummary: metadata.tool_summary ?? metadata.toolSummary ?? [],
    createdAt: raw.created_at ?? raw.createdAt,
  };
}

export const copilotService = {
  async getMessages(conversationId: string): Promise<CopilotMessage[]> {
    const data = await api.get<Record<string, any>[]>(
      `/conversations/${conversationId}/copilot/messages`,
    );
    return data.map(mapCopilotMessage);
  },

  async sendMessage(conversationId: string, content: string): Promise<CopilotMessage> {
    const data = await api.post<Record<string, any>>(
      `/conversations/${conversationId}/copilot/messages`,
      { content },
    );
    return mapCopilotMessage(data);
  },

  mapCopilotMessage,
};
